module.exports = __webpack_public_path__ + "static/logo_oceanbleu-9f8879487143e29dd34786ee71e32483.jpg";